import statuses from '@/store/statuses';
import Services from '@/services/index';
import VT from '@/store/types';

const UsersService = Services.users;
export default {
  [VT.USERS_LIST]: ({ commit, state }, params) => {
    state.usersList['status'] = statuses.LOADING;
    UsersService.list(params).then((data) => {
      commit(VT.USERS_LIST, data);
    }).catch((errResponse) => {
      commit(VT.USERS_LIST, errResponse);
    });
  },
  [VT.USER_CREATE_DATA]: ({ commit, state }) => {
    state.userCreateData['status'] = statuses.LOADING;
    UsersService.createData().then((data) => {
      commit(VT.USER_CREATE_DATA, data);
    }).catch((errResponse) => {
      commit(VT.USER_CREATE_DATA, errResponse);
    });
  },
  [VT.USER_UPDATE_DATA]: ({ commit, state }, userId) => {
    state.userUpdateData['status'] = statuses.LOADING;
    UsersService.editData(userId).then((data) => {
      commit(VT.USER_UPDATE_DATA, data);
    }).catch((errResponse) => {
      commit(VT.USER_UPDATE_DATA, errResponse);
    });
  },
  [VT.USER_CREATE]: ({ commit, state }, createData) => {
    state.userCreate['status'] = statuses.LOADING;
    UsersService.create(createData).then((data) => {
      commit(VT.USER_CREATE, data);
    }).catch((errResponse) => {
      commit(VT.USER_CREATE, errResponse);
    });
  },
  [VT.USER_UPDATE]: ({ commit, state }, { id, update }) => {
    state.userUpdate['status'] = statuses.LOADING;
    UsersService.update(id, update).then((data) => {
      commit(VT.USER_UPDATE, data);
    }).catch((errResponse) => {
      commit(VT.USER_UPDATE, errResponse);
    });
  },
  [VT.USER_UPDATE_ACTIVE]: ({ commit, state }, { id, isActive }) => {
    state.userUpdateActive['status'] = statuses.LOADING;
    UsersService.updateActive(id, isActive).then((data) => {
      commit(VT.USER_UPDATE_ACTIVE, data);
    }).catch((errResponse) => {
      commit(VT.USER_UPDATE_ACTIVE, errResponse);
    });
  },
};
